module.exports = {"430412001":"祝融街道","430412100":"南岳镇","430412203":"寿岳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430412.json
// module id = 1679
// module chunks = 0